import React from "react";
import { connect } from "react-redux";
import { templateStrings, dateFormat, auditViewConstants } from "../../../../../Constant";
import * as moment from "moment";
import { PageWrapper, TableWrapper } from "../../../../../shared/layout";
import { defaultMapDispatchToProps } from "../../../../../redux/map-to-props";
import { fetchCameraLogs } from "../../../../../services/vehicleService";
import { EpochtoEpochTZ, toTitleCaseFromSnake } from "../../../../../shared/utils";
import { masterType } from "../../utils";
import { Paginator, SelectFilter } from "../../../../../shared/widgets";
import PropTypes from "prop-types";
import { ButtonToolbar } from "react-bootstrap";
import { getAllCameraConfigStatus, getAllCameraConfigTypes, getCameraEventLogs } from "../../../../../services/vehicleMasterService";

class Audit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.params.id,
      masterType: this.props.params.masterType,
      showPaginator: false,
      pageNo: 0,
      content: [],
      totalPages: 0,
      name: this.props.location.state?.name || null,
      cameraConfigTypes: [],
      cameraConfigStatus: [],
      selectedCameraLogType: auditViewConstants.cameraLogTypes[0],
      selectedConfigType: null,
      selectedConfigStatus: null,
    };
    this.getList = this.getList.bind(this);
  }

  onFilterChange(value, key) {
    this.setState({ [key]: value, pageNo: 0 }, () => {
      const isCameraMasterPage = this.props.params.masterType === masterType.camera;
      if (key === "selectedCameraLogType" && value?.value === auditViewConstants.logTypes.event && isCameraMasterPage) {
        this.fetchCameraConfigMeta();
      }
      if (key === "selectedCameraLogType" && value?.value !== auditViewConstants.logTypes.event) {
        this.setState({ selectedConfigType: null, selectedConfigStatus: null });
      }
      this.fetchCameraLogs();
    });
  }



  componentDidMount() {
    this.mounted = true;
    this.fetchCameraLogs();
  }

  render() {
    const isCameraMasterPage = this.props.params.masterType === masterType.camera;
    const isEventLogType = this.state.selectedCameraLogType?.value === auditViewConstants.logTypes.event;
    let templateStrings_data;
    if (isCameraMasterPage && isEventLogType) {
      templateStrings_data = templateStrings.eventLogs;
    } else if (isCameraMasterPage) {
      templateStrings_data = templateStrings.cameraLogs;
    } else {
      templateStrings_data = templateStrings.masterLogs;
    }
    const headingText = this.state.name || this.state.id || auditViewConstants.messages.defaultHeading;

    return (
      <div>
        <PageWrapper.Header
          heading={headingText}
          hideS={true}
        ></PageWrapper.Header>
        <PageWrapper.Body>
          {isCameraMasterPage && (
            <div className="header-button-container">
              <div className="form-group">
                <p className="filters-label">Filter By:</p>
                <div
                  className="dataTables_length wrapper-gps"
                  id="dataTables-example_length"
                >
              <ButtonToolbar>
    
                <SelectFilter
                  value={this.state.selectedCameraLogType}
                  onChange={(value) => {
                    this.onFilterChange(value, "selectedCameraLogType");
                  }}
                  getOptionValue={(option) => `${option['value']}`}
                  getOptionLabel={(option) => `${option['label']}`}
                  placeholder={auditViewConstants.filterPlaceholders.logType}
                  options={auditViewConstants.cameraLogTypes}
                />

                  {this.props.params.masterType === masterType.camera && this.state.selectedCameraLogType?.value === auditViewConstants.logTypes.event && (
                    <>
                      <SelectFilter
                        value={this.state.selectedConfigType}
                        onChange={(value) => this.onFilterChange(value, "selectedConfigType")}
                        clearable={true}
                        getOptionValue={(option) => `${option['value']}`}
                        getOptionLabel={(option) => `${option['label']}`}
                        placeholder={auditViewConstants.filterPlaceholders.configType}
                        options={this.state.cameraConfigTypes}
                      />
                      <SelectFilter
                        value={this.state.selectedConfigStatus}
                        onChange={(value) => this.onFilterChange(value, "selectedConfigStatus")}
                        clearable={true}
                        getOptionValue={(option) => `${option['value']}`}
                        getOptionLabel={(option) => `${option['label']}`}
                        placeholder={auditViewConstants.filterPlaceholders.configStatus}
                        options={this.state.cameraConfigStatus}
                      />
                    </>
                  )}

                  </ButtonToolbar>
                </div>
              </div>
            </div>)}
          <TableWrapper>
            <TableWrapper.Header columns={templateStrings_data} />
            {
              <tbody>
                {this.state.content &&
                  this.state.content.length > 0 &&
                  this.state.content.map((data) => {
                    return this.displayList(data, templateStrings_data);
                  })}
                {(!this.state.content ||
                  (this.state.content && this.state.content.length === 0)) && (
                  <tr className="gradeA odd noDataStyle" role="row">
                    <td className="sorting_1" colSpan={auditViewConstants.table.colSpan}>
                      {auditViewConstants.messages.noDataFound}
                    </td>
                  </tr>
                )}
              </tbody>
            }
          </TableWrapper>
          {this.state.showPaginator && (
            <Paginator
              pageNo={this.state.pageNo}
              totalPages={this.state.totalPages}
              getList={this.getList}
            />
          )}
          </PageWrapper.Body>
      </div>
    );
  }

  fetchCameraLogs() {
    if (this.mounted) this.props.updateLoader(true);

    const isCameraMasterPage = this.props.params.masterType === masterType.camera;
    const selectedLogType = this.state.selectedCameraLogType?.value;

    if (isCameraMasterPage && selectedLogType === auditViewConstants.logTypes.event) {
      const configType = this.state.selectedConfigType?.value;
      const configStatus = this.state.selectedConfigStatus?.value;
      getCameraEventLogs(this.state.id, configType, configStatus, this.state.pageNo, auditViewConstants.pagination.pageSize)
        .then((res) => {
          if (this.mounted) {
            this.setState({
              content: res.items || [],
              totalPages: res.totalPages || 0,
              pageNo: res.currentPage || 0,
              showPaginator: true,
            }, () => {
              this.props.updateLoader(false);
            });
          }
        })
        .catch((err) => this.errorHandler(err));
      return;
    }

    fetchCameraLogs(this.state.id, this.state.masterType, this.state.pageNo)
      .then((res) => {
        if (this.mounted) {
          this.setState((prevState) => ({
            content: prevState.masterType === "camera" ? res : res.items,
            totalPages: prevState.masterType === "camera" ? 1 : res.totalPages,
            pageNo: prevState.masterType === "camera" ? 1 : res.currentPage,
            showPaginator: prevState.masterType !== "camera",
          }), () => {
            this.props.updateLoader(false);
          });
        }
      })
      .catch((err) => {
        this.errorHandler(err);
      });
  }

  fetchCameraConfigMeta() {
    getAllCameraConfigTypes()
      .then((res) => {
        const options = (res || []).map((item) => ({ label: toTitleCaseFromSnake(item), value: item }));
        if (this.mounted) this.setState({ cameraConfigTypes: options });
      })
      .catch(() => {});

    getAllCameraConfigStatus()
      .then((res) => {
        const options = (res || []).map((item) => ({ label: toTitleCaseFromSnake(item), value: item }));
        if (this.mounted) this.setState({ cameraConfigStatus: options });
      })
      .catch(() => {});
  }

  errorHandler(err) {
    if (err.status === 401 || err.message === "Invalid token") {
      this.props.setTokenExpired(true);
    } else if (this.mounted) {
      this.props.updateLoader(false);
      this.setState({ content: [] });
      this.props.initiateNotification({
        type: "error",
        message: err.description || auditViewConstants.messages.fetchError,
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /**
   * Used to show  data in row in List view
   * @param item  Object of item to display
   */
  displayList(item, tableHeaderMappings) {
    const getOtherAuditColumn = (column)=>{
      return item[column] ? item[column] : "";
    }
    const getFormattedDate = () => {
      const rawTimestamp = item.modifiedDate || item.createdDate || item.updatedAt;
      const epochTime = parseInt(rawTimestamp, 10);
      const timeZone = localStorage.getItem("timeZone");
      return moment(new Date(EpochtoEpochTZ(epochTime, timeZone))).format(dateFormat);
    };
    return (
      <tr key={item.id}>
        {Object.keys(tableHeaderMappings).map((column, index) => {
          const showTooltip = column !== "action" && column !== "modifiedDate";
        const isDateColumn = column === "modifiedDate" || column === "createdDate" || column === "updatedAt";
          return (
            <td
              className="master-table"
              data-toggle="tooltip"
              title={showTooltip ? item[column] : ""}
              key={column}
            >
              {isDateColumn ? getFormattedDate() : getOtherAuditColumn(column)}
            </td>
          );
        })}
      </tr>
    );
  }
  getList(pageNo) {
    console.log(pageNo)
      if (pageNo >= 0 && pageNo <= this.state.totalPages) {
        this.setState({pageNo},()=>{
          this.fetchCameraLogs();
        })
      }
  }
}

Audit.propTypes = {
  params: PropTypes.object,
  location: PropTypes.object,
  updateLoader: PropTypes.func,
  setTokenExpired: PropTypes.func,
  initiateNotification: PropTypes.func,
};

export default connect(null, defaultMapDispatchToProps)(Audit);
